import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Home, Info, Mail, FileText, Shield, Settings, Edit } from 'lucide-react';
import PageEditor from './PageEditor';

const PageManagerModule = () => {
  const [selectedPage, setSelectedPage] = useState<string | null>(null);

  const pages = [
    { id: 'homepage', name: 'עמוד הבית', icon: Home, description: 'הדף הראשי של האתר' },
    { id: 'about', name: 'אודות', icon: Info, description: 'עמוד אודות החברה' },
    { id: 'contact', name: 'צור קשר', icon: Mail, description: 'עמוד יצירת קשר' },
    { id: 'terms', name: 'תנאי שימוש', icon: FileText, description: 'תנאי השימוש באתר' },
    { id: 'privacy', name: 'מדיניות פרטיות', icon: Shield, description: 'מדיניות הפרטיות' },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">ניהול תוכן עמודים</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {pages.map((page) => (
          <Card key={page.id} className="hover:shadow-md transition-shadow">
            <CardHeader className="pb-3">
              <CardTitle className="flex items-center gap-2 text-lg">
                <page.icon className="h-5 w-5" />
                {page.name}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground mb-4">
                {page.description}
              </p>
              <Button
                onClick={() => setSelectedPage(page.id)}
                className="w-full"
                variant="outline"
              >
                <Edit className="h-4 w-4 ml-2" />
                ערוך תוכן
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>

      {selectedPage && (
        <PageEditor
          pageId={selectedPage}
          onClose={() => setSelectedPage(null)}
        />
      )}
    </div>
  );
};

export default PageManagerModule;